import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { PriceChargingItem } from '@/class/model/price/PriceChargingItem'
import { editQuotationStatus, saveQuotation } from '@/api/price/quotation'
import { QuotationPrePortLastMileDetail } from '@/class/model/price/QuotationPrePortLastMileDetail'
import { Quotation } from '@/class/model/price/Quotation'
import uidUtil from '@/utils/uidUtil'

export default {

  methods: {
    toFileQuery() {
      this.fileHistoryHp.toFileQuery()
    },
    fileRemove() {
      const rows = this.file.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.view.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      // 删除校验
      if (!this.$store.getters.isAdmin) {
        const row = rows.find(p => p.extendMetaData &&
            this.$store.getters.userId !== Number(p.extendMetaData.createdBy) &&
            p.extendMetaData.belong === SystemConstants.FILE_BELONG_INQUIRY.code)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FileFromInquiry'))
          return
        }
      }
      this.fileHistoryHp.fileRemove()
    },
    fileDownload() {
      this.fileHistoryHp.fileDownload()
    },
    fileSendEmail() {
      this.fileHistoryHp.fileSendEmail()
    },
    // 按箱型计费条目
    getChargingItemByEqSizeDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.$store.getters.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.$store.getters.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'),
          colId: 'currency',
          field: 'currency',
          initialWidth: 180,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }
        },
        {
          headerName: '20GP',
          colId: 'gp20', field: 'gp20',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        },
        // {
        //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
        // },
        {
          headerName: '40GP',
          colId: 'gp40', field: 'gp40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: '40HC',
          colId: 'hc40', field: 'hc40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: '45HC',
          colId: 'hc45', field: 'hc45',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: '20NOR',
          colId: 'nor20', field: 'nor20',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: '40NOR',
          colId: 'nor40', field: 'nor40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: (params) => this.onCellChange(params)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SpecialRemark'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }
      ]
    },

    // 非按箱型计费条目
    getChargingItemNotByEqSizeDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.$store.getters.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.$store.getters.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'),
          colId: 'currency',
          field: 'currency',
          initialWidth: 180,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }
        },
        {
          headerName: this.$t('SeaExport.MeasureCurrency'),
          colId: 'measure',
          field: 'measure',
          initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              // methodParams: this.getChargeMeasureFilter(),
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        }
      ]
    },

    init() {
      this.isEdit = this.canUpdate && this.form.status2 !== SystemConstants.QUOTE_STATUS_QUOTED.code
      if (this.form.uuid) {
        this.fileHistoryHp.init()
      }
    },

    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },

    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currencySet = new Set(results)
    },

    cancel() {
      if (!this.form.uuid) {
        this.$emit('cancel')
      }
      this.form = this.originForm
      this.selectedRow = null
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
      this.isEdit = false
    },

    edit() {
      this.form = deepClone(this.originForm)
      this.selectedRow = null
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
      this.isEdit = true
    },

    // 保存
    save() {
      // 运价信息里-哪些必填
      if (this.form.prePortLastMileDetails && this.form.prePortLastMileDetails.length > 0) {
        let checkPress = true
        this.form.prePortLastMileDetails.forEach(p => {
          if (this.type === SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) {
            if (!p.supplier) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Vendor'))
              checkPress = false
              return
            }
          }
          if (!p.beginDate || !p.endDate) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_DateFrom'))
            checkPress = false
            return
          }
          if (p.chargingItemByEqSize && p.chargingItemByEqSize.length > 0) {
            p.chargingItemByEqSize.forEach(item => {
              if (!item.chargeItemId) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_chargeItem'))
                checkPress = false
                return
              }
              if (!item.currency) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_currency'))
                checkPress = false
                return
              }
            })
          }
          if (p.chargingItemNotByEqSize && p.chargingItemNotByEqSize.length > 0) {
            p.chargingItemNotByEqSize.forEach(item => {
              if (!item.chargeItemId) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_chargeItem'))
                checkPress = false
                return
              }
              if (!item.currency) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_currency'))
                checkPress = false
                return
              }
              if (!item.measure) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.MeasureCurrency'))
                checkPress = false
                return
              }
              if (!item.unitRate) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_unitPrice'))
                checkPress = false
                return
              }
            })
          }
        })
        if (!checkPress) {
          return
        }
      }
      this.loading = getLoading4Cxt()
      saveQuotation(this.form).then(async res => {
        const jobModel = new Quotation(this.form)
        jobModel.prePortLastMileDetails = ''
        await jobModel.loadQuotationRelated({
          quotation: true,
          quotationPrePortLastMileDetail: true
        })
        this.originForm = this.form
        this.isEdit = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },

    addChargingItem(chargingItemType) {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('Pricing.PriceInfo'))
        return
      }
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        const item = new PriceChargingItem().fillDefaultValue().getData()
        item.type = SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
        item.tempUuid = uidUtil.createUID()
        this.selectedRow.byEqSizeChargingItems.push(item)
      } else {
        const item = new PriceChargingItem().fillDefaultValue().getData()
        item.type = SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
        item.tempUuid = uidUtil.createUID()
        this.selectedRow.notByEqSizeChargingItems.push(item)
      }
    },

    delChargingItem(chargingItemType) {
      if (!this.selectedRow) {
        return
      }
      let selectedRows
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        selectedRows = this.chargingItemByEqSize.selectedRows
        this.chargingItemByEqSize.selectedRows = []
      } else {
        selectedRows = this.chargingItemNotByEqSize.selectedRows
        this.chargingItemNotByEqSize.selectedRows = []
      }
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }

      const delUuids = []
      const delTempUuids = []
      selectedRows.forEach(row => {
        if (row.uuid) {
          delUuids.push(row.uuid)
        } else {
          delTempUuids.push(row.tempUuid)
        }
      })
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        this.selectedRow.byEqSizeChargingItems = this.selectedRow.byEqSizeChargingItems
          .filter(item => delUuids.indexOf(item.uuid) === -1 && delTempUuids.indexOf(item.tempUuid) === -1)
      } else {
        this.selectedRow.notByEqSizeChargingItems = this.selectedRow.notByEqSizeChargingItems
          .filter(item => delUuids.indexOf(item.uuid) === -1 && delTempUuids.indexOf(item.tempUuid) === -1)
      }

      this.form.delPrePortLastMileChargingItemUuids = [...this.form.delPrePortLastMileChargingItemUuids, ...delUuids]
    },

    addQuotationDetail() {
      const item = new QuotationPrePortLastMileDetail().fillDefaultValue().getData()
      item.pol = this.form.pol
      item.pod = this.form.pod
      item.priceMethod = this.form.transportMode
      item.branchLine = this.form.branchLine
      item.remarks = this.form.remarks
      item.tempUuid = uidUtil.createUID()
      this.form.prePortLastMileDetails.push(item)
    },

    delQuotationDetail() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const delUuids = []
      const delTempUuids = []
      this.selectedRows.forEach(row => {
        if (row.uuid) {
          delUuids.push(row.uuid)
        } else {
          delTempUuids.push(row.tempUuid)
        }
      })

      this.form.prePortLastMileDetails = this.form.prePortLastMileDetails
        .filter(item => delUuids.indexOf(item.uuid) === -1 && delTempUuids.indexOf(item.tempUuid) === -1)

      this.form.delPrePortLastMileDetailUuids = [...this.form.delPrePortLastMileDetailUuids, ...delUuids]

      if (this.selectedRow && (delUuids.indexOf(this.selectedRow.uuid) > -1 || delTempUuids.indexOf(this.selectedRow.tempUuid) > -1)) {
        this.selectedRow = null
      }
      this.selectedRows = []
    },

    editStatus(action) {
      // 撤回报价 报价方式为"已有运价"的报价单，无法撤回
      if (action === SystemConstants.QUOTE_ACTION_REVOKE.code &&
          this.form.quotationMethod === SystemConstants.QUOTATION_METHOD_HAS_PRICE.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_QuoteMethod_ExistingRate'))
        return
      }
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      editQuotationStatus({
        uuid: this.form.uuid,
        action,
        refuseReason: this.refuseQuotationDialog.refuseReason,
        version: this.form.version
      }).then(async res => {
        if (action === SystemConstants.QUOTE_ACTION_REFUSE.code) {
          this.refuseQuotationDialog.refuseReason = ''
          this.refuseQuotationDialog.visible = false
        }
        this.form.status2 = res.data
        const jobModel = new Quotation(this.form)
        jobModel.prePortLastMileDetails = ''
        await jobModel.loadQuotationRelated({
          quotation: true,
          quotationPrePortLastMileDetail: true
        })
        this.originForm = this.form
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    // detail() {
    //   loadQuotationRelated({ quotationPrePortLastMileDetail: true }).then(res => {
    //     this.form.quotationDetail = res.data.quotationDetail
    //   })
    // },

    onCellChange(params) {
      const field = params.colDef.field
      if (['gp20', 'gp40', 'hc40', 'hc45', 'nor20', 'nor40'].indexOf(field) > -1) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    onPriceMethodCellChange(params) {
      const data = params.data
      if (!data) {
        return
      }
      // 直拖需要情况支线类型
      if (params.newValue === SystemConstants.PRICE_METHOD_DIRECT.code) {
        data.branchLine = 0
        this.gridApi.refreshCells({ force: true })
      }
    }
  }
}
